<template>
  <transition name="fade">
    <div class="Terms" v-if="visible">
      <img
        class="Terms-logo"
        ref="logo"
        src="@/assets/img/logo.svg"
        alt="Carta Blanca"
      />
      <div class="Terms-close" @click="$emit('close')" />
      <AvisoApi />
    </div>
  </transition>
</template>

<script>
import AvisoApi from "@/components/AvisoApi";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  components: {
    AvisoApi,
  },
};
</script>

<style lang="stylus" scoped>
@import 'Terms.styl';
</style>
